import { render, staticRenderFns } from "./DeliveryQuestion.vue?vue&type=template&id=d174e07c"
import script from "./DeliveryQuestion.vue?vue&type=script&lang=js"
export * from "./DeliveryQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports